import { LegacyAffiliateVehiclesPanel } from "@/components/organisms/Vehicles/LegacyMyVehicles/LegacyAffiliateVehiclesPanel";

export const LegacyAffiliateVehicles = () => {
  return <LegacyAffiliateVehiclesPanel />;
};
